import RichTextField from './RichTextField';
import { isRichText } from '../utils/richText';

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** The club's plan comes with the formatting bar (utils/richText). */
  rich: boolean;
  id?: string;
  className?: string;
  rows?: number;
  placeholder?: string;
  maxLength?: number;
  required?: boolean;
  compact?: boolean;
}

/**
 * A club-written body: the formatting bar on Club and Pro, the plain text box
 * otherwise. A body that already carries formatting keeps the bar whatever the
 * plan, so a club that moves to Free never sees raw tags in a text box.
 */
function BodyField({ value, onChange, rich, id, className = 'form-textarea', rows = 4, placeholder, maxLength, required, compact }: Props) {
  if (rich || isRichText(value)) {
    return <RichTextField id={id} value={value} onChange={onChange} placeholder={placeholder} compact={compact} />;
  }
  return (
    <textarea
      id={id}
      className={className}
      rows={rows}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      required={required}
    />
  );
}

export default BodyField;
